/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../public/upgrade/core/datepicker/datepicker-range.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '@angular/core/src/linker/element_ref';
import * as import10 from '../../../../../public/upgrade/core/datepicker/calendar-config';
import * as import11 from '@angular/core/src/linker/query_list';
import * as import12 from '../../../../../public/upgrade/core/datepicker/date-input/date-input.component';
import * as import13 from './date-input/date-input.component.ngfactory';
import * as import14 from '../../../../../public/upgrade/core/datepicker/calendar-view/calendar-view.component';
import * as import15 from './calendar-view/calendar-view.component.ngfactory';
import * as import16 from '@ngx-translate/core/src/translate.service';
export class Wrapper_DatePickerRangeComponent {
  /*private*/ _eventHandler:Function;
  context:import0.DatePickerRangeComponent;
  /*private*/ _changed:boolean;
  /*private*/ _changes:{[key: string]:any};
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  /*private*/ _expr_2:any;
  /*private*/ _expr_3:any;
  /*private*/ _expr_4:any;
  /*private*/ _expr_5:any;
  /*private*/ _expr_6:any;
  /*private*/ _expr_7:any;
  subscription0:any;
  constructor(p0:any,p1:any) {
    this._changed = false;
    this._changes = {};
    this.context = new import0.DatePickerRangeComponent(p0,p1);
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
    this._expr_2 = import1.UNINITIALIZED;
    this._expr_3 = import1.UNINITIALIZED;
    this._expr_4 = import1.UNINITIALIZED;
    this._expr_5 = import1.UNINITIALIZED;
    this._expr_6 = import1.UNINITIALIZED;
    this._expr_7 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
    (this.subscription0 && this.subscription0.unsubscribe());
  }
  check_position(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.position = currValue;
      this._changes['position'] = new import1.SimpleChange(this._expr_0,currValue);
      this._expr_0 = currValue;
    }
  }
  check_format(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this._changed = true;
      this.context.format = currValue;
      this._changes['format'] = new import1.SimpleChange(this._expr_1,currValue);
      this._expr_1 = currValue;
    }
  }
  check_disableDates(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_2,currValue))) {
      this._changed = true;
      this.context.disableDates = currValue;
      this._changes['disableDates'] = new import1.SimpleChange(this._expr_2,currValue);
      this._expr_2 = currValue;
    }
  }
  check_locale(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_3,currValue))) {
      this._changed = true;
      this.context.locale = currValue;
      this._changes['locale'] = new import1.SimpleChange(this._expr_3,currValue);
      this._expr_3 = currValue;
    }
  }
  check_period(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_4,currValue))) {
      this._changed = true;
      this.context.period = currValue;
      this._changes['period'] = new import1.SimpleChange(this._expr_4,currValue);
      this._expr_4 = currValue;
    }
  }
  check_errors(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_5,currValue))) {
      this._changed = true;
      this.context.errors = currValue;
      this._changes['errors'] = new import1.SimpleChange(this._expr_5,currValue);
      this._expr_5 = currValue;
    }
  }
  check_fromPlaceholder(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_6,currValue))) {
      this._changed = true;
      this.context.fromPlaceholder = currValue;
      this._changes['fromPlaceholder'] = new import1.SimpleChange(this._expr_6,currValue);
      this._expr_6 = currValue;
    }
  }
  check_toPlaceholder(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_7,currValue))) {
      this._changed = true;
      this.context.toPlaceholder = currValue;
      this._changes['toPlaceholder'] = new import1.SimpleChange(this._expr_7,currValue);
      this._expr_7 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) {
      if (changed) {
        this.context.ngOnChanges(this._changes);
        this._changes = {};
      }
      if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); }
    }
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any,emit0:boolean):void {
    this._eventHandler = _eventHandler;
    if (emit0) { (this.subscription0 = this.context.periodUpdated.subscribe(_eventHandler.bind(view,'periodUpdated'))); }
  }
}
var renderType_DatePickerRangeComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_DatePickerRangeComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.DatePickerRangeComponent>;
  _DatePickerRangeComponent_0_3:Wrapper_DatePickerRangeComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_DatePickerRangeComponent_Host0,renderType_DatePickerRangeComponent_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'sara-datepicker-range',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_DatePickerRangeComponent0(this.viewUtils,this,0,this._el_0);
    this._DatePickerRangeComponent_0_3 = new Wrapper_DatePickerRangeComponent(new import9.ElementRef(this._el_0),this.injectorGet(import10.CalendarConfig,this.parentIndex));
    this.compView_0.create(this._DatePickerRangeComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._DatePickerRangeComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.DatePickerRangeComponent) && (0 === requestNodeIndex))) { return this._DatePickerRangeComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._DatePickerRangeComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
    this._DatePickerRangeComponent_0_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const DatePickerRangeComponentNgFactory:import8.ComponentFactory<import0.DatePickerRangeComponent> = new import8.ComponentFactory<import0.DatePickerRangeComponent>('sara-datepicker-range',View_DatePickerRangeComponent_Host0,import0.DatePickerRangeComponent);
const styles_DatePickerRangeComponent:any[] = ([] as any[]);
var renderType_DatePickerRangeComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_DatePickerRangeComponent,{});
export class View_DatePickerRangeComponent0 extends import2.AppView<import0.DatePickerRangeComponent> {
  _viewQuery_fromCalendar_0:import11.QueryList<any>;
  _viewQuery_toCalendar_1:import11.QueryList<any>;
  _viewQuery_fromDateInput_2:import11.QueryList<any>;
  _viewQuery_toDateInput_3:import11.QueryList<any>;
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  compView_4:import2.AppView<import12.DateInputComponent>;
  _DateInputComponent_4_3:import13.Wrapper_DateInputComponent;
  _text_5:any;
  _el_6:any;
  compView_6:import2.AppView<import14.CalendarViewComponent>;
  _CalendarViewComponent_6_3:import15.Wrapper_CalendarViewComponent;
  _text_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _el_11:any;
  compView_11:import2.AppView<import12.DateInputComponent>;
  _DateInputComponent_11_3:import13.Wrapper_DateInputComponent;
  _text_12:any;
  _el_13:any;
  compView_13:import2.AppView<import14.CalendarViewComponent>;
  _CalendarViewComponent_13_3:import15.Wrapper_CalendarViewComponent;
  _text_14:any;
  _text_15:any;
  _text_16:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_DatePickerRangeComponent0,renderType_DatePickerRangeComponent,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._viewQuery_fromCalendar_0 = new import11.QueryList<any>();
    this._viewQuery_toCalendar_1 = new import11.QueryList<any>();
    this._viewQuery_fromDateInput_2 = new import11.QueryList<any>();
    this._viewQuery_toDateInput_3 = new import11.QueryList<any>();
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','-lg-12 -md-3 -sm-3'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray4(4,'class','-lg-3 -md-3 -sm-3','style','padding-left: 0px; padding-bottom: 10px;'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'date-input',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_4 = new import13.View_DateInputComponent0(this.viewUtils,this,4,this._el_4);
    this._DateInputComponent_4_3 = new import13.Wrapper_DateInputComponent(new import9.ElementRef(this._el_4),this.parentView.injectorGet(import16.TranslateService,this.parentIndex));
    this.compView_4.create(this._DateInputComponent_4_3.context);
    this._text_5 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_2,'calendar-view',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_6 = new import15.View_CalendarViewComponent0(this.viewUtils,this,6,this._el_6);
    this._CalendarViewComponent_6_3 = new import15.Wrapper_CalendarViewComponent(this.renderer,new import9.ElementRef(this._el_6));
    this.compView_6.create(this._CalendarViewComponent_6_3.context);
    this._text_7 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_8 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_9 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','-lg-3 -md-3 -sm-12 sara-dp-end'),(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'\n        ',(null as any));
    this._el_11 = import3.createRenderElement(this.renderer,this._el_9,'date-input',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_11 = new import13.View_DateInputComponent0(this.viewUtils,this,11,this._el_11);
    this._DateInputComponent_11_3 = new import13.Wrapper_DateInputComponent(new import9.ElementRef(this._el_11),this.parentView.injectorGet(import16.TranslateService,this.parentIndex));
    this.compView_11.create(this._DateInputComponent_11_3.context);
    this._text_12 = this.renderer.createText(this._el_9,'\n        ',(null as any));
    this._el_13 = import3.createRenderElement(this.renderer,this._el_9,'calendar-view',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_13 = new import15.View_CalendarViewComponent0(this.viewUtils,this,13,this._el_13);
    this._CalendarViewComponent_13_3 = new import15.Wrapper_CalendarViewComponent(this.renderer,new import9.ElementRef(this._el_13));
    this.compView_13.create(this._CalendarViewComponent_13_3.context);
    this._text_14 = this.renderer.createText(this._el_9,'\n    ',(null as any));
    this._text_15 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_16 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_4,new import3.InlineArray4(4,'click',(null as any),'focusout',(null as any)),this.eventHandler(this.handleEvent_4));
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_6,new import3.InlineArray4(4,'dateSelected',(null as any),'mousedown',(null as any)),this.eventHandler(this.handleEvent_6));
    this._CalendarViewComponent_6_3.subscribe(this,this.eventHandler(this.handleEvent_6),true);
    var disposable_2:Function = import3.subscribeToRenderElement(this,this._el_11,new import3.InlineArray4(4,'click',(null as any),'focusout',(null as any)),this.eventHandler(this.handleEvent_11));
    var disposable_3:Function = import3.subscribeToRenderElement(this,this._el_13,new import3.InlineArray4(4,'dateSelected',(null as any),'mousedown',(null as any)),this.eventHandler(this.handleEvent_13));
    this._CalendarViewComponent_13_3.subscribe(this,this.eventHandler(this.handleEvent_13),true);
    this._viewQuery_fromCalendar_0.reset([this._CalendarViewComponent_6_3.context]);
    this.context.fromCalendar = this._viewQuery_fromCalendar_0.first;
    this._viewQuery_toCalendar_1.reset([this._CalendarViewComponent_13_3.context]);
    this.context.toCalendar = this._viewQuery_toCalendar_1.first;
    this._viewQuery_fromDateInput_2.reset([this._DateInputComponent_4_3.context]);
    this.context.fromDateInput = this._viewQuery_fromDateInput_2.first;
    this._viewQuery_toDateInput_3.reset([this._DateInputComponent_11_3.context]);
    this.context.toDateInput = this._viewQuery_toDateInput_3.first;
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._text_15,
      this._text_16
    ]
    ),[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import12.DateInputComponent) && (4 === requestNodeIndex))) { return this._DateInputComponent_4_3.context; }
    if (((token === import14.CalendarViewComponent) && (6 === requestNodeIndex))) { return this._CalendarViewComponent_6_3.context; }
    if (((token === import12.DateInputComponent) && (11 === requestNodeIndex))) { return this._DateInputComponent_11_3.context; }
    if (((token === import14.CalendarViewComponent) && (13 === requestNodeIndex))) { return this._CalendarViewComponent_13_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_4_0_0:any = this.context.fromPlaceholder;
    this._DateInputComponent_4_3.check_placeholder(currVal_4_0_0,throwOnChange,false);
    const currVal_4_0_1:any = this.context.fromDateAsString();
    this._DateInputComponent_4_3.check_selected(currVal_4_0_1,throwOnChange,false);
    const currVal_4_0_2:any = ((this.context.errors == null)? (null as any): this.context.errors.from);
    this._DateInputComponent_4_3.check_error(currVal_4_0_2,throwOnChange,false);
    this._DateInputComponent_4_3.ngDoCheck(this,this._el_4,throwOnChange);
    const currVal_6_0_0:any = this.context.isFromCalendarOpen();
    this._CalendarViewComponent_6_3.check_openedCalendar(currVal_6_0_0,throwOnChange,false);
    const currVal_6_0_1:any = this.context.locale;
    this._CalendarViewComponent_6_3.check_locale(currVal_6_0_1,throwOnChange,false);
    const currVal_6_0_2:any = this.context.format;
    this._CalendarViewComponent_6_3.check_format(currVal_6_0_2,throwOnChange,false);
    const currVal_6_0_3:any = this.context.position;
    this._CalendarViewComponent_6_3.check_position(currVal_6_0_3,throwOnChange,false);
    const currVal_6_0_4:any = this.context.disableDates;
    this._CalendarViewComponent_6_3.check_disableDates(currVal_6_0_4,throwOnChange,false);
    const currVal_6_0_5:any = this.context.startElement;
    this._CalendarViewComponent_6_3.check_rangeBound(currVal_6_0_5,throwOnChange,false);
    const currVal_6_0_6:any = this.context.period;
    this._CalendarViewComponent_6_3.check_period(currVal_6_0_6,throwOnChange,false);
    this._CalendarViewComponent_6_3.ngDoCheck(this,this._el_6,throwOnChange);
    const currVal_11_0_0:any = this.context.toPlaceholder;
    this._DateInputComponent_11_3.check_placeholder(currVal_11_0_0,throwOnChange,false);
    const currVal_11_0_1:any = this.context.toDateAsString();
    this._DateInputComponent_11_3.check_selected(currVal_11_0_1,throwOnChange,false);
    const currVal_11_0_2:any = ((this.context.errors == null)? (null as any): this.context.errors.to);
    this._DateInputComponent_11_3.check_error(currVal_11_0_2,throwOnChange,false);
    this._DateInputComponent_11_3.ngDoCheck(this,this._el_11,throwOnChange);
    const currVal_13_0_0:any = this.context.isToCalendarOpen();
    this._CalendarViewComponent_13_3.check_openedCalendar(currVal_13_0_0,throwOnChange,false);
    const currVal_13_0_1:any = this.context.locale;
    this._CalendarViewComponent_13_3.check_locale(currVal_13_0_1,throwOnChange,false);
    const currVal_13_0_2:any = this.context.format;
    this._CalendarViewComponent_13_3.check_format(currVal_13_0_2,throwOnChange,false);
    const currVal_13_0_3:any = this.context.position;
    this._CalendarViewComponent_13_3.check_position(currVal_13_0_3,throwOnChange,false);
    const currVal_13_0_4:any = this.context.disableDates;
    this._CalendarViewComponent_13_3.check_disableDates(currVal_13_0_4,throwOnChange,false);
    const currVal_13_0_5:any = this.context.endElement;
    this._CalendarViewComponent_13_3.check_rangeBound(currVal_13_0_5,throwOnChange,false);
    const currVal_13_0_6:any = this.context.period;
    this._CalendarViewComponent_13_3.check_period(currVal_13_0_6,throwOnChange,false);
    this._CalendarViewComponent_13_3.ngDoCheck(this,this._el_13,throwOnChange);
    this.compView_4.internalDetectChanges(throwOnChange);
    this.compView_6.internalDetectChanges(throwOnChange);
    this.compView_11.internalDetectChanges(throwOnChange);
    this.compView_13.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_4.destroy();
    this.compView_6.destroy();
    this.compView_11.destroy();
    this.compView_13.destroy();
    this._CalendarViewComponent_6_3.ngOnDestroy();
    this._CalendarViewComponent_13_3.ngOnDestroy();
  }
  handleEvent_4(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.handleClickInputFrom()) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'focusout')) {
      const pd_sub_1:any = ((<any>this.context.hideFromCalendar()) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
  handleEvent_6(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'dateSelected')) {
      const pd_sub_0:any = ((<any>this.context.fromDateSelected($event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'mousedown')) {
      const pd_sub_1:any = ((<any>this.context.preventCloseFrom()) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
  handleEvent_11(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.handleClickInputTo()) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'focusout')) {
      const pd_sub_1:any = ((<any>this.context.hideToCalendar()) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
  handleEvent_13(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'dateSelected')) {
      const pd_sub_0:any = ((<any>this.context.toDateSelected($event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'mousedown')) {
      const pd_sub_1:any = ((<any>this.context.preventCloseTo()) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/core/datepicker/datepicker-range.component.ngfactory.ts